export default {"src":"/_next/static/media/home-2.8c530f77.svg","height":1339,"width":1440};